var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendMsgIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_81_44",
    "data-name": "Component 81 \\u2013 44",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "send",
    d: "M38.988,57.064l-.008,0L17.665,48.105a1.163,1.163,0,0,0-1.109.109A1.25,1.25,0,0,0,16,49.255v5.727a1.209,1.209,0,0,0,.974,1.191L28.6,58.351a.2.2,0,0,1,0,.4L16.975,60.926A1.209,1.209,0,0,0,16,62.116v5.728a1.193,1.193,0,0,0,1.188,1.2,1.212,1.212,0,0,0,.475-.1l21.315-8.9.009,0a1.626,1.626,0,0,0,0-2.972Z",
    transform: "translate(-14.978 -45.527)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMsgIcon);
export default __webpack_public_path__ + "static/media/send-msg-icon.a6362876426c16a632093d51d053e526.svg";
export { ForwardRef as ReactComponent };